'use client'

import { forwardRef } from 'react'
import { IMaskInput } from 'react-imask'
import { cn } from '@/utils/utils'

type PhoneInputProps = {
  value?: string
  onAccept?: (value: string) => void
  className?: string
  placeholder?: string
  disabled?: boolean
}

export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ value, onAccept, className, ...props }, ref) => {
    return (
      <IMaskInput
        mask="(00) 00000-0000"
        value={value}
        onAccept={(value) => onAccept?.(value)}
        inputRef={ref}
        className={cn(
          'h-9 w-full min-w-0 rounded-3xl border border-transparent bg-input/50 px-3 py-1 text-base transition-[color,box-shadow,background-color] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/30 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40',
          className,
        )}
        {...props}
      />
    )
  },
)

PhoneInput.displayName = 'PhoneInput'
